const getStringLength = (string, excludeWhitespaces) =>
  excludeWhitespaces ? string.replace(/\s/g, '').length : string.length;

export default getStringLength;
